import controller from './thing-labels.controller';

const template = require('./thing-labels.html');

export default {
    bindings: {
        reset: '<',
        labels: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-labels/thing-labels.component.js